














import Vue from "vue";

import IconSpeakerActive from "@joyz/app-core/assets/icons/default/Speaker.svg";
import IconSpeakerInactive from "@joyz/app-core/assets/icons/transparent/Speaker.svg";

interface Props {
  avatarUrl: string;
  iconSpeakerActive: string;
  iconSpeakerInactive: string;
  isAudioPlaying: boolean;
}

export default Vue.extend<Props>({
  functional: true,

  props: {
    avatarUrl: { type: String, required: true },
    iconSpeakerActive: { type: String, default: IconSpeakerActive },
    iconSpeakerInactive: { type: String, default: IconSpeakerInactive },
    isAudioPlaying: { type: Boolean, default: false }
  }
});
